export function addConsentScriptToHead(app) {
    const skipCookieWall = app.context.route.fullPath.includes('acceptCookiePolicy=true');
    if (app.$config.fundaShell.userConsent && !skipCookieWall) {
        const scriptIdDefault = 'e55671d2-c3ec-4ee2-a126-f60cb0a7fe01';
        const env = app.$config.fundaShell.env;
        const scriptIdConfig = (env && env !== 'prod')
            ? 'd2G368VD'
            : 'ydnBrNxj';
        app.head.__dangerouslyDisableSanitizersByTagID = app.head.__dangerouslyDisableSanitizersByTagID || {};
        app.head.__dangerouslyDisableSanitizersByTagID['consent-script'] = ['innerHTML'];

        // @nuxtjs/i18n (app.$fundaShell.i18n.currentLocale) uses browser language as initial value (first load) before setting the fallbackLocale
        const locale = app.context.route.path.includes('/en/') ? 'en' : 'nl';
        app.head.script.push({
            hid: 'consent-script',
            innerHTML: `
                window.didomiConfig = {
                    user: { bots: { consentRequired: false } },
                    languages: { enabled: ["${locale}"], default: "${locale}" }
                };
                window.gdprAppliesGlobally=false;(function(){function n(e){if(!window.frames[e]){if(document.body&&document.body.firstChild){var t=document.body;var r=document.createElement("iframe");r.style.display="none";r.name=e;r.title=e;t.insertBefore(r,t.firstChild)}else{setTimeout(function(){n(e)},5)}}}function e(r,i,o,c,s){function e(e,t,r,n){if(typeof r!=="function"){return}if(!window[i]){window[i]=[]}var a=false;if(s){a=s(e,n,r)}if(!a){window[i].push({command:e,version:t,callback:r,parameter:n})}}e.stub=true;e.stubVersion=2;function t(n){if(!window[r]||window[r].stub!==true){return}if(!n.data){return}var a=typeof n.data==="string";var e;try{e=a?JSON.parse(n.data):n.data}catch(t){return}if(e[o]){var i=e[o];window[r](i.command,i.version,function(e,t){var r={};r[c]={returnValue:e,success:t,callId:i.callId};n.source.postMessage(a?JSON.stringify(r):r,"*")},i.parameter)}}if(typeof window[r]!=="function"){window[r]=e;if(window.addEventListener){window.addEventListener("message",t,false)}else{window.attachEvent("onmessage",t)}}}e("__tcfapi","__tcfapiBuffer","__tcfapiCall","__tcfapiReturn");n("__tcfapiLocator");(function(e,t){var r=document.createElement("link");r.rel="preconnect";r.as="script";var n=document.createElement("link");n.rel="dns-prefetch";n.as="script";var a=document.createElement("link");a.rel="preload";a.as="script";var i=document.createElement("script");i.id="spcloader";i.type="text/javascript";i["async"]=true;i.charset="utf-8";var o="https://sdk.privacy-center.org/"+e+"/loader.js?target_type=notice&target="+t;r.href="https://sdk.privacy-center.org/";n.href="https://sdk.privacy-center.org/";a.href=o;i.src=o;var c=document.getElementsByTagName("script")[0];c.parentNode.insertBefore(r,c);c.parentNode.insertBefore(n,c);c.parentNode.insertBefore(a,c);
                c.parentNode.insertBefore(i,c)})("${scriptIdDefault}","${scriptIdConfig}")})();
            `,
        });
    }
}

// The purposes ids are defined in Didomi console:
// https://console.didomi.io/funda/data-manager/purposes
export const purposes = Object.freeze({
    functional: 'functional-group',
    analytical: 'analytical-group',
    personalization: 'personalisation-group',
    ads: 'advertisement-group',
});

export const getValue = ({ source, split, hint } = {}) =>
    source.split(split).find(row => row.startsWith(hint));

// @todo: use only localStorage once funda.website is gone
function hasConsentsCookie() {
    return !!document.cookie.includes('didomi_consent=');
}

function getConsentsCookieValue() {
    if (!hasConsentsCookie()) { return; }

    const consentCookieValue = getValue({
        source: document.cookie,
        split: '; ',
        hint: 'didomi_consent=',
    });
    return consentCookieValue;
}

function addCookies(acceptAll = false) {
    const cookieValue = acceptAll ? Object.values(purposes) : window.didomiState?.didomiPurposesConsent;
    const thisDomain = (/funda.nl/.test(window.location.hostname)) ? '.funda.nl' : window.location.hostname;
    const cookieDomainPath = `domain=${thisDomain}; path=/; max-age=${3600 * 1000 * 24 * 365 * 10}`;
    document.cookie = `didomi_consent=${cookieValue};${cookieDomainPath}`;
    document.cookie = `userConsentPersonalization=${hasConsentFor(purposes.personalization)};${cookieDomainPath}`;
}

export function hasConsentFor(id) {
    const consentCookie = getConsentsCookieValue();
    return !!consentCookie?.includes(id);
}

export function hasClosedModal() {
    const cookieName = 'euconsent-v2';
    return !!document.cookie.includes(cookieName) || !!window.localStorage.getItem(cookieName);
}

export function resetAnonymousId() {
    if (window.didomiState?.didomiPurposesConsent?.includes(purposes.personalization)) {
        window.dispatchEvent(new Event('resetTracking'));
    } else {
        window.dispatchEvent(new Event('setAnonymousTracking'));
    }
}

export default {
    init() {
        window.didomiOnReady = window.didomiOnReady || [];
        window.didomiOnReady.push(function() {
            if (!hasConsentsCookie()) { addCookies(); };
        });

        window.didomiEventListeners = window.didomiEventListeners || [];
        window.didomiEventListeners.push({
            event: 'consent.changed',
            listener: function() {
                addCookies();
                resetAnonymousId();
                window.location.reload();
            },
        });

        this.addCookiesIfAcceptCookiePolicyUrl();
    },
    addCookiesIfAcceptCookiePolicyUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const acceptCookiePolicy = urlParams.get('acceptCookiePolicy');
        if (acceptCookiePolicy) {
            addCookies(true);
        }
    },
    showDialog() {
        window.Didomi?.preferences?.show();
    },

    functional: () => hasConsentFor(purposes.functional),
    analytical: () => hasConsentFor(purposes.analytical),
    personalization: () => hasConsentFor(purposes.personalization),
    ads: () => hasConsentFor(purposes.ads),
};
